import { NavLink, Outlet } from "react-router-dom";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";

export default function ComponentsHome() {
  return (
    <Container>
      <h1>Component Library</h1>
      <div className="pb-16 flex flex-col gap-4">
        <NavLink to={"positive-you"}>Positive You</NavLink>
        <NavLink to={"wisdom-academy"}>Wisdom Academy</NavLink>
        <NavLink to={"wisdom-reward"}>Wisdom Reward</NavLink>
        <NavLink to={"support-moments"}>Support Moments</NavLink>
        <NavLink to={"student-hub"}>Student Hub</NavLink>
        <NavLink to={"resources"}>Resources</NavLink>
        <NavLink to={"wisdom-ai"}>Wisdom AI</NavLink>
      </div>
      <div className="space-y-8">
        <Outlet />
      </div>
    </Container>
  );
}
